<template>
  <div
    class="input-wrapper awsome-wrapper starts-appoitment all-day-wrapper timing-wrapper show-awsome-select main-content"
  >
    <div class="title-wrapper position-relative">
      <span class="ver-center">Date</span>
    </div>
    <div class="content-wrapper position-relative">
      <div
        class="date-wrapper ver-center show-awsome-select calendar-wrapper text-right r-10 toggle-calendar full-width"
      >
        <input
          type="date"
          name="date"
          class="text-only-input calendar-width ml-10"
          :value="formattedDate"
          @change="changeDate"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { dateAndTimeMixin } from "../../../../mixins/dateAndTimeMixin";

export default {
  mixins: [dateAndTimeMixin],
  computed: {
    ...mapGetters({
      date: "getDate", // Gets the currently selected date
      selectedMonth: "getSelectedMonth", // Gets the currently selected month
      selectedYear: "getSelectedYear", // Gets the currently selected year
      selectedDayOfmonth: "getSelectedDayOfMonth" // Gets the currently selected day of the month
    }),
    formattedDate() {
      return this.formatDate({
        dayOfMonth: this.date.dayOfMonth,
        month: this.date.month,
        year: this.date.year
      });
    }
  },
  methods: {
    ...mapMutations({
      setDate: "setDate" // Set the currently selected date
    })
  },
  created() {
    this.setDate({
      dayOfMonth: this.selectedDayOfmonth,
      month: this.selectedMonth,
      year: this.selectedYear
    });
  }
};
</script>

<style scoped>
.calendar-width {
  text-align: right !important;
}
</style>
